import { parse, isValid, parseISO } from 'date-fns'
import {
  formatInTimeZone as dateFnsFormatInTimeZone,
  format,
  OptionsWithTZ,
} from 'date-fns-tz'
import { ptBR } from 'date-fns/locale'

export const sliceText = (title: string, maxLength: number) =>
  title.length > maxLength ? `${title.slice(0, maxLength)}...` : title

export function isAuthorized(accessRule: boolean): boolean {
  return accessRule === true || accessRule === undefined
}

export const isDateValid = (date: string, inputFormat: string) => {
  try {
    if (inputFormat === 'UTC')
      return isValid(
        parse(
          dateFnsFormatInTimeZone(date, 'UTC', 'yyyy-MM-dd', {
            locale: ptBR,
            timeZone: 'UTC',
          }),
          'yyyy-MM-dd',
          new Date(),
          { locale: ptBR }
        )
      )
    else return isValid(parse(date, inputFormat, new Date(), { locale: ptBR }))
  } catch (ex: any) {}
}

export const formatUTCDatetime = (date: string, outputFormat: string) => {
  try {
    if (isDateValid(date, 'UTC'))
      return dateFnsFormatInTimeZone(parseISO(date), 'UTC', outputFormat, {
        locale: ptBR,
        timeZone: 'UTC',
      })
  } catch (ex: any) {}
}

export const formatDatetime = (
  date: string,
  inputFormat: string,
  outputFormat: string
) => {
  try {
    if (isDateValid(date, inputFormat))
      return format(parse(date, inputFormat, new Date()), outputFormat, {
        locale: ptBR,
      })
  } catch (ex: any) {}
}

export const formatInTimeZone = (
  date: Date | string | number,
  timeZone: string,
  formatStr: string,
  options?: OptionsWithTZ
): string => {
  if (
    !date ||
    (typeof date === 'string' && !isDateValid(date, formatStr)) ||
    !isValid(date)
  )
    return ''

  return dateFnsFormatInTimeZone(date, timeZone, formatStr, options)
}

export const toTitleCase = (phrase: string) =>
  phrase
    .toLowerCase()
    .split(' ')
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

export const navigateToInstitute = () =>
  (window.location.href = 'https://www.institutojef.org.br')

export const composePath = (path: string, course?: string) =>
  course ? `/${course}${path}` : path

export const isCpfValid = (cpf: string) => {
  if (typeof cpf !== 'string') return false
  cpf = cpf.replace(/[^\d]+/g, '')
  if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false
  const digits = cpf.split('')
  const validator = digits
    .filter((digit, index, array) => index >= array.length - 2 && digit)
    .map((el) => +el)
  const toValidate = (pop: number) =>
    digits
      .filter((digit, index, array) => index < array.length - pop && digit)
      .map((el) => +el)
  const rest = (count: number, pop: number) =>
    ((toValidate(pop).reduce((soma, el, i) => soma + el * (count - i), 0) *
      10) %
      11) %
    10
  return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1])
}

export const cleanCpf = (cpf: string) =>
  cpf.replace(new RegExp('[.-]*', 'gm'), '')

export const isJSON = (json: any) => {
  try {
    JSON.parse(json)
    return true
  } catch (e) {
    return false
  }
}
